import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled.div`
    padding: 8px 16px;
`;

export const Footer = styled(FlexRow)`
    flex-direction: row-reverse;
    height: 36px;
    margin-top: 16px;
    align-items: center;
`;
export const TitleContainer = styled(FlexRow)`
    margin-bottom: 4px;
    justify-content: space-between;
    svg {
        width: 100%;
        height: 100%;
    }
    > button {
        flex-shrink: 0;
        margin-left: 20px;
    }
`;
export const Title = styled.div`
    ${mixins.setFont({ $size: 14, $weight: 500, $color: colorsPalettes.carbon[0] })};
`;
export const Text = styled.div`
    ${mixins.setFont({ $size: 13, $color: colorsPalettes.carbon[0] })};
`;

export const FilterNotificationWrapper = styled.div`
    cursor: default;
    pointer-events: auto;
    margin-right: 9px;
    margin-left: 10px;
`;
